import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Learnspace } from '@shared/models';

@Component({
  selector: 'hub-community-card',
  templateUrl: './hub-community-card.component.html',
  styleUrls: ['./hub-community-card.component.scss']
})
export class HubCommunityCardComponent {
  @Input() learnspace!: Learnspace;
  @Input() canRemix = false;
  @Input() remixEnabled = true;
  @Input() remixLoading = false;
  @Output() launchClick = new EventEmitter<void>();
  @Output() remixClick = new EventEmitter<void>();

  get posterUrl(): string | null {
    return this.learnspace.postermedia?.path ?? null;
  }

  get hubLogoUrl(): string | null {
    return (this.learnspace as any).hub?.logo?.path ?? null;
  }

  get hubName(): string {
    return (this.learnspace as any).hub?.title ?? '';
  }
}
